"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFacets = void 0;
const createSimpleFilter_1 = require("../core/createSimpleFilter");
function createFacets(facets) {
    return Object.freeze(facets.map((facet) => ({
        fieldId: facet.fieldId,
        displayName: facet.displayName,
        options: createFacetOptions(facet.options)
    })));
}
exports.createFacets = createFacets;
function createFacetOptions(options) {
    return options.map((option) => ({
        displayName: option.displayName,
        count: option.count,
        selected: option.selected,
        filter: createSimpleFilter_1.createSimpleFilter(option.filter)
    }));
}
